import { useEffect } from 'react';
import { setRequestComponent } from './requestSource';

const useRequestSource = (componentName: string, isActive = true) => {
  useEffect(() => {
    if (isActive) {
      setRequestComponent(componentName);
    } else {
      setRequestComponent('');
    }
    return () => setRequestComponent('');
  }, [componentName, isActive]);
};

export default useRequestSource;
